import React from 'react';
import '../styles/global.css';
import SEO from './seo';

interface LayoutProps {
  title: string;
  description: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, title, description }) => {  
  return (
    <>
      <SEO title={title} description={description} />
      {children}
    </>
  );
};
